export const UPDATE_SA_DAILY_EXPORT_SETTING_NAME =
  "update_search_analytics_daily_export_setting";
export const UPDATE_SA_DAILY_EXPORT_SETTING_DESC = `Updates the Daily Export spreadsheet setting for Search Analytics.

Use when the user wants to set or change the Google Spreadsheet used for daily export.

Input:
- 'spreadsheetId' (required): Spreadsheet ID from the URL (not the full URL).
- Provide exactly one target:
  - 'viewId': Search Analytics View ID (updates a specific view's daily export), OR
  - 'searchAnalyticsId': Search Analytics ID (updates the default view), OR
  - 'projectId': Search Analytics Project ID (the tool resolves the Search Analytics ID).

Notes:
- Write operation (mutation). Requires confirmation.
- For projectId, the tool fetches the Search Analytics ID before updating.`;
